import { Button } from 'antd';
import { AppstoreOutlined, SettingOutlined } from '@ant-design/icons';

type ProjectCardProps = {
	projectName: string;
	onSettings?: () => void;
};

export const ProjectCard = ({ projectName, onSettings }: ProjectCardProps) => (
	<div
		style={{
			background: 'transparent',
			borderRadius: 10,
			minWidth: 200,
			maxWidth: 340,
			width: '100%',
			border: '1px solid rgba(148, 163, 184, 0.28)',
			padding: '10px 12px',
			boxSizing: 'border-box',
		}}
	>
		<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
			<div style={{ minWidth: 0, flex: 1, overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
				<AppstoreOutlined style={{ marginRight: 4, color: '#94a3b8' }} />
				<span
					style={{
						fontWeight: 600,
						fontSize: 13,
						color: '#0f172a',
						lineHeight: 1.3,
					}}
				>
					{projectName}
				</span>
			</div>
			{onSettings ? (
				<Button
					type="text"
					onClick={onSettings}
					size="small"
					style={{ borderRadius: 20, flexShrink: 0 }}
				>
					<SettingOutlined style={{ color: 'dodgerblue' }} />
				</Button>
			) : null}
		</div>
		<div
			style={{
				marginTop: 4,
				fontSize: 11,
				color: '#94a3b8',
				lineHeight: 1.35,
			}}
		>
			Proyecto
		</div>
	</div>
);
